import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import BsFormControl from 'react-bootstrap/lib/FormControl';
import { debounce, isNil } from 'lodash';
import { GetValidationPattern } from '../../../util/ValidationUtil.js';
import { formatClassName } from '../../../Util';
import i18n from '../../../i18n/translate';

export default class FormControl extends React.Component {
  static propTypes = {
    activeLanguage: PropTypes.any,
    caption: PropTypes.string,
    className: PropTypes.string,
    componentClass: PropTypes.string,
    dataValue: PropTypes.any,
    disableSubmit: PropTypes.bool,
    errorMessage: PropTypes.string,
    languages: PropTypes.any,
    max: PropTypes.string,
    min: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onValueChange: PropTypes.func,
    pattern: PropTypes.string,
    required: PropTypes.bool,
    runValidation: PropTypes.any,
    scrollContainerId: PropTypes.string,
    searchField: PropTypes.any,
    setError: PropTypes.func,
    type: PropTypes.string,
    valueChangeDelay: PropTypes.number,
    valueOverride: PropTypes.bool
  };

  static defaultProps = {
    valueChangeDelay: 1000
  };

  constructor(props) {
    super(props);
    this.isValid = this.isValid.bind(this);
    this.checkError = this.checkError.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.debouncedValueChange = debounce(this.debouncedValueChange.bind(this),
      this.props.valueChangeDelay, { leading: false, trailing: true });
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.state = { value: !isNil(props.dataValue) ? props.dataValue : '' };
    this.pattern = GetValidationPattern(props.type, props.pattern);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.valueOverride && newProps.dataValue !== this.state.value) {
      this.onChange(newProps.dataValue, true)
    }
  }

  onFormChange(e) {
    this.onChange(e.currentTarget.value)
  }

  onChange(value, skipValueChange) {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value);
    }
    if (!skipValueChange) {
      this.debouncedValueChange(value);
    }
    this.setState({ value });
  }

  isValid() {
    return ReactDOM.findDOMNode(this.input).validity.valid;
  }

  onBlur(e) {
    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(this.state.value);
    }
    this.checkError();

    if (!e?.currentTarget?.value) return;

    if (e.currentTarget.value !== this.props.dataValue) {
      if (typeof this.props.onValueChange === 'function') {
        this.props.onValueChange({ [this.props.name]: e.currentTarget.value });
      }
      this.debouncedValueChange.cancel();
    }
  }

  debouncedValueChange(value) {
    if (typeof this.props.onValueChange === 'function') {
      this.props.onValueChange({ [this.props.name]: value });
    }
  }

  onFocus() {
    if (typeof this.props.onFocus === 'function') {
      this.props.onFocus();
    }
  }

  checkError() {
    if (this.input) {
      let message = ReactDOM.findDOMNode(this.input) && (ReactDOM.findDOMNode(this.input).validity.valueMissing ? i18n.t("This field is required") : null)

      if (!message && this.props.type && this.props.type.toLowerCase() === "email") {
        let pattern = new RegExp(GetValidationPattern(this.props.type));
        if (!pattern.test(this.state.value)) {
          message = i18n.t('The email you entered is invalid');
        }
      }

      if (typeof this.props.setError === 'function') {
        this.props.setError(!this.isValid(), message);
      }
    }
  }

  handleKeyPress(e) {
    if (this.props.disableSubmit) {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    }
  }

  render() {
    let { className, componentClass, setError, dataValue, onValueChange, valueChangeDelay, valueOverride, scrollContainerId, disableSubmit, // eslint-disable-line no-unused-vars
      caption, searchField, runValidation, activeLanguage, languages, // eslint-disable-line no-unused-vars
      ...props } = this.props;

    className = formatClassName([className, { 'p-r-10': componentClass === 'textarea' }]);

    return (<BsFormControl
      {...props}
      className={className}
      componentClass={componentClass}
      onChange={this.onFormChange}
      onBlur={this.onBlur}
      onFocus={this.onFocus}
      onKeyPress={this.handleKeyPress}
      pattern={this.pattern}
      ref={(input) => (this.input = input)}
      value={this.state.value}
    />);
  }
}
